export const LithiumMetalBatteriesContainedInEquipment = 'LithiumMetalBatteriesContainedInEquipment';
export const LithiumMetalBatteriesPackedWithEquipment = 'LithiumMetalBatteriesPackedWithEquipment';
export const LithiumMetalBatteriesStandAlone = 'LithiumMetalBatteriesStandAlone';
export const LithiumIonBatteriesContainedInEquipment = 'LithiumIonBatteriesContainedInEquipment';
export const LithiumIonBatteriesPackedWithEquipment = 'LithiumIonBatteriesPackedWithEquipment';
export const LithiumIonBatteriesStandAlone = 'LithiumIonBatteriesStandAlone';
export const LimitedQuantitiesCanadaOnly = 'LimitedQuantitiesCanadaOnly';
